import React from "react";
import "./CityModal.scss";
import { IoMdClose } from "react-icons/io";
function CityModal({ hotelInfo,cityInfo, showModal }) {
  return (
    <div className="modal-box">
      <div className="modal">
        <div className="close">
          <IoMdClose
            size="2rem"
            color="#1F5DA2"
            className="closeBtn"
            onClick={() => showModal(false)}
          />
        </div>
        <h1>{hotelInfo?hotelInfo.name:cityInfo.name}</h1>
        <p>
          {hotelInfo?hotelInfo.description:cityInfo.description}
        </p>
        {hotelInfo?<h2>Ссылки</h2>:<h2>Топ 5 Достопримечательностей</h2>}
        <ul className={hotelInfo?'linksUl':""}>
          {hotelInfo?
          hotelInfo?.links?.map((el) => (
            <li key={el}><a href={el.url} target="_blank">{el.source}</a></li>
            
          )):
          cityInfo?.attractions?.map((el) => (
            <li key={el}>{el}</li>
          ))
          }
          
        </ul>
      </div>
    </div>
  );
}

export default CityModal;
